// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3FUfN","right":"styles_right__1eMTq"};